import styled, { css } from "styled-components/macro";
import { BannerFont, DefaultFont, HeaderFont } from "../styles/fonts";
import React from "react";


// The root div for all rootpage pages.
export const ContentDiv = styled.div`
  background-color: white;
  display: block;
  position: relative;
  width: 100%;
  margin: 0 auto 0;

  padding: 5% 15% 10% 15%;

  @media ${(props) => props.theme.media.phone} {
    padding: 2rem 0rem 2rem 0rem;
  }

  p {
    ${DefaultFont}
  }

  h3 {
    ${DefaultFont};
    color: ${(props) => props.theme.text.color.orange};
  }

  h2 {
    ${HeaderFont}
  }

  h1 {
    &:first-child {
      margin-bottom: 2em;
    }
    ${BannerFont}
  }

  & > section:not(:last-child),
  & > div:not(:last-child){
    margin-bottom: 10em;
    @media ${(props) => props.theme.media.phone} {
      margin-bottom: 3em;
    }
  }`;

interface IFSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  reverse?: boolean;
  grow?: number;
  notCentering?: boolean;
}

export const FlexSection = styled.div<IFSectionProps>`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${(props) => props.reverse ? "row-reverse" : "row"};

  align-items: ${props => props.notCentering ? "normal" : "center"};
  gap: 2rem;

  & > * {
    flex: 1 1 ${(props) => props.grow ? props.grow : "50"}%;
  }
`;

interface IHSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  readonly outline?: boolean;
}

// A one line div for hilighted information (phone numbers etc). With or without outline.
export const HighlightedSection = styled.div<IHSectionProps>`
  ${DefaultFont};

  width: fit-content;
  white-space: nowrap;

  margin-bottom: 0.6em;

  &>svg{
    vertical-align: middle;
    margin-right: 1ex;
  }

  background-color: ${(props) => props.theme.colors.bgSecondary};
  padding: 1rem;

  border-width: 1px;
  border-color: ${(props) => props.theme.colors.borderSecondary};
  border-style: ${(props) => props.outline ? 'solid' : 'hidden'};
  border-radius: 8px;

`;


export const MainFlow = styled.div<{ isIOS: boolean, isSafari: any, marginAuto: boolean }>`
  & #bold {
    font-weight: 600 !important;
  }
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  display: grid;
  grid-template-areas:
    "hospi-header"
    "hospi-main";
  grid-template-rows: auto 1fr;
  #hospi-header {
    grid-area: hospi-header;
  }
  #hospi-main {

    & > div:first-child {
      margin: ${(props) => props.marginAuto ? '0 auto' : ''};
      min-height: calc(100vh - 96px);
    }
    width: 100%;
    grid-area: hospi-main;
    height: calc(100vh - ${(props: { isIOS: boolean, isSafari: any }) => (props.isIOS && !props.isSafari) ? '130px' : '96px'});
    scroll-behavior: smooth;
    overflow-y: scroll;
    overflow-x: auto;
  }
`;

// Use for Login page
export const ContainerLogin = styled.div`
  min-height: calc(100vh - 146px) !important;
  max-width: 336px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin: 0 auto 50px auto;
  //padding: ${(props) => props.theme.sizes.heightHeaderDesktop} 0;
  @media (max-width: 500px) {
    justify-content: flex-start;
    height: calc(100vh + 50px);
  }
`;
// Redirect to login
export const ContainerRedirect = styled.div`
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  border: 1px solid ${(props) => props.theme.colors.border};
  background-color: ${(props) => props.theme.colors.place};
  padding: 24px;
  max-width: 384px;
  width: 100%;
`;

export const HostStudentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(155px, 1fr));
  gap: 16px;
  width: 100%;
  & > div > label {
    width: 100%;
    justify-content: flex-start;
    padding: 0.5em 0.5em 0.5em 24px;
  }
`;
interface IPopupM {
  top?: string;
  right?: string;
}
// Use FC PopupMenu, MultiSelect, SelectLanguage
export const ContainerPopupMenu = styled.div<IPopupM>`
  position: absolute;
  top: ${(props) => props.top || "0"};
  right: ${(props) => props.right || "0"};
  width: max-content;
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  border: 1px solid ${(props) => props.theme.colors.border};
  background-color: ${(props) => props.theme.colors.place};
  opacity: 0;
  transition: 0.7s;
  &.active {
    opacity: 1;
  }
  & a {
    display: block;
    width: 100%;
    &:hover {
      background-color: ${(props) => props.theme.colors.secondary};
    }
  }
  & .logout:hover {
    background-color: ${(props) => props.theme.colors.secondary};
  }
`;

interface DialogProps {
  readonly maxWidthDlg?: string;
}

export const DialogWrapper = styled.div<DialogProps>`
  display: grid;
  gap: 16px;
  padding: 24px;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, auto);

  & > .buttons {
    display: inline-grid;
    gap: 16px;
    justify-self: end;
    grid-template-columns: repeat(2, max-content);
  }
  @media (max-width: 400px) {
    padding: 16px;
    & > .buttons {
      justify-self: center;
      grid-template-columns: 1fr;
      & > button {
        min-width: 60vw;
      }
    }
  }
`;

export const ContainerTitleEdit = styled.div`
  display: flex;
  justify-content: space-between;
  & a {
    text-decoration: none;
  }
  @media ${(props) => props.theme.media.phone} {
    & > * label {
      display: none;
    }
  }
`;
// StudentProfileView
export const ContainerSearch = styled.div`
  padding-top: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  width: 100%;
  gap: 24px;
  @media ${(props) => props.theme.media.phone} {
    grid-template-columns: 1fr;
  }
`;

export const ContainerRegistration = styled.div`
  display: flex;
  padding-top: 64px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  max-width: ${(props) => props.theme.sizes.maxWidthMainWindow};
  margin: 0 1rem;
  & .buttonGroup {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    & button {
      margin: 16px 0 0 24px;
    }
  }
  @media (max-width: 890px) {
    padding-top: 0px;
    & .buttonGroup {
      flex-direction: column;
      & button {
        width: 100% !important;
        margin: 16px 0 0 0;
      }
    }
  }
`;

export const ContainerView = styled.div`
  display: grid;
  grid-template-columns: 270px 1fr;
  margin: 0 auto;
  padding: 64px 8px 4em 8px;
  max-width: ${(props) => props.theme.sizes.maxWidthMainWindow};
  transition: 0.3s all ease;
  @media ${(props) => props.theme.media.leftmenu} {
    grid-template-columns: 1fr;
    padding: 0 1rem 4em 1rem;
    margin: 1rem 0;
  }
  position: relative;
  & label {
    word-break: break-word;
  }
`;

export const ConteinerLeftSide = styled.div`
  position: fixed;
  top: 106px;
  left: center;
  align-self: flex-start;
  width: 248px;
  height: 343px;
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  border: 1px solid ${(props) => props.theme.colors.border};
  background-color: ${(props) => props.theme.colors.place};
  padding: 24px 16px;
  @media ${(props) => props.theme.media.leftmenu} {
    display: none;
  }

  & a {
    text-decoration: none;
    padding: 8px 8px 8px 16px;
    cursor: pointer;
    display: block;
    border-radius: 4px;
    margin-bottom: 8px;

    &.active {
      background-color: ${(props) => props.theme.colors.secondary};

      label {
        font-weight: 600;
      }
    }
  }
`;

// Use page UserProfile
export const ContainerGeneric = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 16px;
  background-color: ${(props) => props.theme.colors.bgBody};
  // width: 100%;
  max-width: ${(props) => props.theme.sizes.maxWidthMainWindow};
  // margin: 70px auto 0;
  margin-top: 1rem;
  @media ${(props) => props.theme.media.phone} {
    grid-template-columns: 1fr;
    margin: 0 auto;
    padding: 0 1rem;
  }
  @media ${(props) => props.theme.media.tablet} {
    grid-template-columns: 1fr;
    margin: 0 auto;
    padding: 0 1rem;
  }
`;
export const ContainerNotice = styled.div`
  background-color: transparent;
  display: block;
  width: 100%;
  color: ${(props) => props.theme.colors.text};
  & > h3 {
    font-size: ${(props) => props.theme.font.size};
    font-weight: ${(props) => props.theme.font.weightBold};
    color: ${(props) => props.theme.colors.text};
    margin: 0;
  }
  & > p {
    margin: 0;
  }
  @media ${(props) => props.theme.media.phone} {
    display: none;
  }
`;
export const ContainerValue = styled.div<
  { maxWidth?: string } & React.HTMLAttributes<HTMLDivElement>
>`
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  border: 1px solid ${(props) => props.theme.colors.border};
  background-color: ${(props) => props.theme.colors.place};
  padding: 24px;
  max-width: ${(props) => props.maxWidth || "initial"};
  width: 100%;
  margin-bottom: 24px;
  word-break: break-word;
  @media ${(props) => props.theme.media.phone} {
    margin-bottom: 24px;
    padding: 24px 8px;
    word-break: break-word;
  }
`;

export const ContainerValueExtra = styled.div<
  { maxWidth?: string } & React.HTMLAttributes<HTMLDivElement>
>`
  max-width: ${(props) => props.maxWidth || "initial"};
  width: 100%;
  min-height: 6rem;
`;

export const ContainerTitleProfile = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  gap: 16px;
  width: 100%;
  // margin-bottom: 24px;
  & > label {
    align-self: end;
  }
  @media ${(props) => props.theme.media.leftmenu} {
    // margin-top: 2.5rem;
    grid-template-columns: 1fr max-content;
  }

  @media ${(props) => props.theme.media.phone} {
    grid-template-columns: max-content;
  }
`;
export const ContainerValueView = styled(ContainerValue)`
  flex-grow: 1;
  width: 100%;
  margin-bottom: 24px;
`;
// Use FC Header
export const ContainerMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: ${(props) => props.theme.sizes.maxWidthMainWindow};
  margin: 0 auto;
  height: 100%;

  @media ${(props) => props.theme.media.tablet} {
    padding: 0 1.8rem;
  }

  @media ${(props) => props.theme.media.phone} {
    padding: 0 1.8rem;
  }
`;

// Use page Login, FC InputCalendar, Input, Select, MultiSelect, SelectLanguage
export const StyledBlock = styled.div<{
  w?: string;
  grow?: string;
  p?: string;
}>`
  display: block;
  position: relative;
  width: ${(props) => props.w || "100%"};
  padding: ${(props) => props.p || "initial"};
  flex-grow: ${(props) => props.grow || "0"};
  line-height: 1.8em;
`;
export interface IFlex extends React.HTMLAttributes<HTMLDivElement> {
  readonly justify?: string;
  readonly align?: string;
  readonly direction?: string;
  readonly wrap?: string;
  readonly gap?: string;
  readonly padding?: string;
  readonly margin?: string;
  readonly grow?: number;
  readonly width?: string;
}
// Use page Login, Home, StudentProfile, Contact
// Use FC InputCalendar, Calendar, MultiSelect, Menu, SelectLanguage, Range
export const FlexBox = styled.div<IFlex>`
  display: flex;
  align-items: ${(props) => props.align || "center"};
  justify-content: ${(props) => props.justify || "center"};
  flex-direction: ${(props) => props.direction || "row"};
  flex-wrap: ${(props) => props.wrap || "wrap"};
  gap: ${(props) => props.gap || "0"};
  padding: ${(props) => props.padding || "0"};
  margin: ${(props) => props.margin || "0"};
  width: ${(props) => props.width || "initial"};
  flex-grow: ${(props) => (props.grow === undefined ? 1 : props.grow)};
`;
interface IBorderBox {
  readonly active?: boolean;
  readonly m?: string;
}
// Use page Login
export const BorderBox = styled.div<IBorderBox>`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  margin: ${(props) => props.m || "initial"};
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  border: 1px solid ${(props) => props.theme.colors.border};
  flex-grow: 1;
  ${(props) =>
    props.active &&
    css`
      background-color: ${(props) => props.theme.colors.activeRadioBox};
      border: 1px solid ${(props) => props.theme.colors.primary};
    `}
`;

export const GridWrapper = styled.div<{ gap?: string }>`
  display: grid;
  gap: ${(props) => props.gap || "0px"};
  & li {
    list-style-type: none;
  }
`;

export const PullGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  justify-items: left;
`;

export const CorrectPullRefresh = styled.div`
  width: 100%;
  & .ptr__children {
    transform: none !important;
  }
`;
